export default __webpack_public_path__ + "static/media/box-dark.140cefe7.svg";